<template>
  <div class="container">
    <div class="mx-auto" style="width: 300px">
      <div class="custom-logo">
        <img src="https://invoicesainet.blob.core.windows.net/images/J_Logo_Black_256x256.png" alt="App" width="128" />
      </div>
      <div class="card">
        <h5 class="card-header">{{ message }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { authStore } from '@/stores/auth'

export default {
  name: 'SsoView',
  data() {
    return {
      message: 'Login to Invoices AI via SSO'
    }
  },
  async mounted() {
    // Extract the temp token from the URL
    const urlParams = new URLSearchParams(window.location.search)
    const tempToken = urlParams.get('token') // Assume the temp token is in the query param 'token'

    if (tempToken) {
      // Exchange the temp token for a JWT
      await this.redeemTempToken(tempToken)
      if (this.token) {
        // Update the message to display the user's first name
        this.message = `Welcome, ${this.profile.firstName}` + '!'

        // Hang for two seconds
        await new Promise((resolve) => setTimeout(resolve, 750))

        // Redirect to the home page
        this.$router.push('/')
      }
    } else {
      // If no token is found, you might want to handle this case
      console.error('No token found in the URL')
    }
  },
  computed: {
    ...mapState(authStore, ['profile', 'token', 'passthrough'])
  },
  methods: {
    ...mapActions(authStore, ['redeemTempToken'])
  }
}
</script>

<style lang="scss" scoped>
.custom-logo {
  width: 300px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
